__turbopack_context__.v({
  "btn": "ThemeToggle-module__LAadvq__btn",
  "glow": "ThemeToggle-module__LAadvq__glow",
});
